var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1773653807220,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 25968,
    width: 64,
    height: 64,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.024 171.712h51.2v157.376h215.424V171.712h51.2v157.376h266.688v51.2h-266.624V486.4h266.624v51.2h-266.624v106.112h266.624v51.2h-266.624v157.376h-51.2v-157.376H404.16v157.376h-51.2v-157.376H86.336v-51.2h266.688V537.6H86.336v-51.2h266.688V380.288H86.336v-51.2h266.688V171.712z m51.2 208.576V486.4h215.424V380.288H404.224zM619.648 537.6H404.224v106.112h215.424V537.6z",
    fill: "#5180F1",
    "p-id": 25969
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.272 218.688c0-25.92 21.056-46.976 46.976-46.976h757.44c25.92 0 46.912 21.056 46.912 46.976v586.624a46.912 46.912 0 0 1-46.912 46.976H133.248a46.912 46.912 0 0 1-46.976-46.976V218.688z m51.2 4.224v578.176H886.4V222.912H137.472z",
    fill: "#5180F1",
    "p-id": 25970
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.1ef48912e6ae204d606f48ec8d71de0a.svg";
export { ForwardRef as ReactComponent };